var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOver(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1512,
    height: 1127,
    viewBox: "0 0 1512 1127",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1951_32086)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1951_32086)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1512 1127.81H1379.5L946 921.5L683.5 1004L491.5 1127.81H0H637L660.75 1090.81L921 1094L937.5 1127L1512 1127.81Z",
    fill: "url(#paint0_linear_1951_32086)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1055.32 718.151L1049.96 719.655L1050.07 720.05L1055.43 718.546L1055.32 718.151Z",
    fill: "#16345A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M485 1131.81L751 961.81",
    stroke: "black",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M996 945.81L1380 1128.81L996 945.81Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M879 972.81L963 1128.81L879 972.81Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M695 982L611 1138",
    stroke: "black",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1110.61 963.53C1020.97 951.61 602.531 969.64 470.381 969.94C424.381 970.05 512.721 1031.53 512.721 1031.53L510.161 1057.19C510.161 1057.19 522.237 1078.6 660.5 1089.93C691.648 1092.48 729.2 1094.51 774.461 1095.68C826.096 1097.02 877.373 1096.6 922 1094.26C977.214 1091.36 1022.25 1085.52 1045.18 1076.43C1070.18 1066.54 1070.84 1052.06 1070.84 1052.06L1066.99 1030.25C1066.99 1030.25 1089.99 1017.12 1099.07 1005.87C1114.66 986.63 1119.05 964.65 1110.61 963.53Z",
    fill: "url(#paint1_linear_1951_32086)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M514 1030.25C514 1030.25 504.57 1054.32 511.43 1058.47C542.06 1077.01 633.89 1092.28 725.7 1095.68C854.02 1100.43 995.65 1095 1055.43 1071.3C1060.78 1069.18 1067.82 1060.39 1069.55 1054.62C1073.09 1042.79 1066.98 1031.53 1066.98 1031.53C1066.98 1031.53 897.19 1046.92 744.98 1046.92C621.93 1046.92 514 1030.25 514 1030.25Z",
    fill: "url(#paint2_linear_1951_32086)",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1110.61 963.53C1020.97 951.61 602.531 969.64 470.381 969.94C424.381 970.05 512.721 1031.53 512.721 1031.53L510.161 1057.19C510.161 1057.19 528.291 1089.34 774.461 1095.68C889.981 1098.68 1003.71 1092.86 1045.18 1076.43C1070.18 1066.54 1070.84 1052.06 1070.84 1052.06L1066.99 1030.25C1066.99 1030.25 1089.99 1017.12 1099.07 1005.87C1114.66 986.63 1119.05 964.65 1110.61 963.53Z",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M730 1044.81C614.3 1045.02 512 1030.81 512 1030.81C512 1030.81 613.3 1049.02 729 1048.81C883.59 1048.53 1043 1032.81 1043 1032.81C1043 1032.81 884.59 1044.53 730 1044.81Z",
    fill: "#000204"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M730 1044.81C614.3 1045.02 512 1030.81 512 1030.81C512 1030.81 613.3 1049.02 729 1048.81C883.59 1048.53 1066 1030.5 1066 1030.5C1066 1030.5 884.59 1044.53 730 1044.81Z",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M818.051 935.98C637.051 934.86 459.491 953.08 457.621 967.44C454.681 989.99 604.321 993.65 785.291 993.65C966.261 993.65 1105.77 981.31 1112.95 968.75C1125.44 946.93 1056.29 937.45 818.051 935.98Z",
    fill: "url(#paint3_linear_1951_32086)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M818.051 935.98C637.051 934.86 459.491 953.08 457.621 967.44C454.681 989.99 604.321 993.65 785.291 993.65C966.261 993.65 1105.77 981.31 1112.95 968.75C1125.44 946.93 1056.29 937.45 818.051 935.98Z",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520 971.81C530.493 971.81 539 968.899 539 965.31C539 961.72 530.493 958.81 520 958.81C509.507 958.81 501 961.72 501 965.31C501 968.899 509.507 971.81 520 971.81Z",
    fill: "url(#paint4_linear_1951_32086)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520 971.81C530.493 971.81 539 968.899 539 965.31C539 961.72 530.493 958.81 520 958.81C509.507 958.81 501 961.72 501 965.31C501 968.899 509.507 971.81 520 971.81Z",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M632 987.81C642.493 987.81 651 984.899 651 981.31C651 977.72 642.493 974.81 632 974.81C621.507 974.81 613 977.72 613 981.31C613 984.899 621.507 987.81 632 987.81Z",
    fill: "url(#paint5_linear_1951_32086)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M632 987.81C642.493 987.81 651 984.899 651 981.31C651 977.72 642.493 974.81 632 974.81C621.507 974.81 613 977.72 613 981.31C613 984.899 621.507 987.81 632 987.81Z",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M972 980.81C982.493 980.81 991 977.899 991 974.31C991 970.72 982.493 967.81 972 967.81C961.507 967.81 953 970.72 953 974.31C953 977.899 961.507 980.81 972 980.81Z",
    fill: "url(#paint6_linear_1951_32086)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M972 980.81C982.493 980.81 991 977.899 991 974.31C991 970.72 982.493 967.81 972 967.81C961.507 967.81 953 970.72 953 974.31C953 977.899 961.507 980.81 972 980.81Z",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M850 988.81C860.493 988.81 869 985.899 869 982.31C869 978.72 860.493 975.81 850 975.81C839.507 975.81 831 978.72 831 982.31C831 985.899 839.507 988.81 850 988.81Z",
    fill: "url(#paint7_linear_1951_32086)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M850 988.81C860.493 988.81 869 985.899 869 982.31C869 978.72 860.493 975.81 850 975.81C839.507 975.81 831 978.72 831 982.31C831 985.899 839.507 988.81 850 988.81Z",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M746 990.81C756.493 990.81 765 987.899 765 984.31C765 980.72 756.493 977.81 746 977.81C735.507 977.81 727 980.72 727 984.31C727 987.899 735.507 990.81 746 990.81Z",
    fill: "url(#paint8_linear_1951_32086)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M746 990.81C756.493 990.81 765 987.899 765 984.31C765 980.72 756.493 977.81 746 977.81C735.507 977.81 727 980.72 727 984.31C727 987.899 735.507 990.81 746 990.81Z",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1058 964.81C1068.49 964.81 1077 961.899 1077 958.31C1077 954.72 1068.49 951.81 1058 951.81C1047.51 951.81 1039 954.72 1039 958.31C1039 961.899 1047.51 964.81 1058 964.81Z",
    fill: "url(#paint9_linear_1951_32086)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1058 964.81C1068.49 964.81 1077 961.899 1077 958.31C1077 954.72 1068.49 951.81 1058 951.81C1047.51 951.81 1039 954.72 1039 958.31C1039 961.899 1047.51 964.81 1058 964.81Z",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M648.721 854.47L678.231 875C678.231 875 735.231 877.88 793.711 877.57C855.711 877.24 919.441 873.72 919.441 873.72L937.441 854.47H648.721Z",
    fill: "url(#paint10_linear_1951_32086)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M648.721 854.47L678.231 875C678.231 875 735.231 877.88 793.711 877.57C855.711 877.24 919.441 873.72 919.441 873.72L937.441 854.47H648.721Z",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M946.39 912.21C940.129 897.599 932.841 883.451 924.58 869.87L669.25 868.58L633.33 966.09C633.33 966.09 714.89 972.44 797.56 971.23C905.9 969.63 961.78 959.68 961.78 959.68C957.755 943.52 952.612 927.658 946.39 912.21V912.21Z",
    fill: "url(#paint11_linear_1951_32086)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M946.39 912.21C940.129 897.599 932.841 883.451 924.58 869.87L669.25 868.58L633.33 966.09C633.33 966.09 714.89 972.44 797.56 971.23C905.9 969.63 961.78 959.68 961.78 959.68C957.755 943.52 952.612 927.658 946.39 912.21V912.21Z",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M780.88 918.619C711.99 918.619 652.57 913.489 652.57 913.489V914.809C694.718 919.841 737.123 922.412 779.57 922.509C857.4 922.509 946.37 914.809 946.37 914.809V913.529C946.37 913.529 858.38 918.619 780.88 918.619Z",
    fill: "#000912"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M780.88 918.619C711.99 918.619 652.57 913.489 652.57 913.489V914.809C694.718 919.841 737.123 922.412 779.57 922.509C857.4 922.509 946.37 914.809 946.37 914.809V913.529C946.37 913.529 858.38 918.619 780.88 918.619Z",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M793.07 858.32C872.787 858.32 937.41 856.023 937.41 853.19C937.41 850.356 872.787 848.06 793.07 848.06C713.354 848.06 648.73 850.356 648.73 853.19C648.73 856.023 713.354 858.32 793.07 858.32Z",
    fill: "url(#paint12_linear_1951_32086)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M647.44 857.04C645.44 858.77 640.09 863.45 632.81 869.46C639.65 863.81 628.87 884.35 603.81 901.94C585.92 914.51 565.72 905.3 565.32 927.6C565.23 932.32 556.96 959.599 561.47 963.529C579.47 979.059 635.88 964.81 635.88 964.81C635.88 964.81 651.11 932.53 653.88 914.81C667.88 898.18 678.25 875.04 678.25 875.04C678.25 875.04 653.94 851.32 647.44 857.04Z",
    fill: "url(#paint13_linear_1951_32086)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M647.44 857.04C645.44 858.77 640.09 863.45 632.81 869.46C639.65 863.81 628.87 884.35 603.81 901.94C585.92 914.51 565.72 905.3 565.32 927.6C565.23 932.32 556.96 959.599 561.47 963.529C579.47 979.059 635.88 964.81 635.88 964.81C635.88 964.81 651.11 932.53 653.88 914.81C667.88 898.18 678.25 875.04 678.25 875.04C678.25 875.04 653.94 851.32 647.44 857.04Z",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1017 910.919C1006.45 902.319 988.58 897.239 974.66 886.549C960.17 875.409 956.31 861.009 938.74 855.749C934.42 854.459 932.74 858.949 929.74 862.169C925.44 866.819 920.74 871.169 920.74 871.169C921.723 875.303 923.462 879.219 925.87 882.719C930.87 890.359 939.63 900.409 945.11 912.229C948.04 918.549 946.73 925.339 948.96 931.469C952.54 941.181 956.828 950.616 961.79 959.699C961.79 959.699 1029.54 958.069 1028.51 955.849C1026.37 951.239 1029.49 921.139 1017 910.919Z",
    fill: "url(#paint14_linear_1951_32086)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1017 910.919C1006.45 902.319 988.58 897.239 974.66 886.549C960.17 875.409 956.31 861.009 938.74 855.749C934.42 854.459 932.74 858.949 929.74 862.169C925.44 866.819 920.74 871.169 920.74 871.169C921.723 875.303 923.462 879.219 925.87 882.719C930.87 890.359 939.63 900.409 945.11 912.229C948.04 918.549 946.73 925.339 948.96 931.469C952.54 941.181 956.828 950.616 961.79 959.699C961.79 959.699 1029.54 958.069 1028.51 955.849C1026.37 951.239 1029.49 921.139 1017 910.919Z",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M802.69 166.809C586.6 164.609 564.05 202.729 564.05 202.729C564.05 202.729 554.89 222.929 584.57 247.639C593.28 254.889 584.45 266.989 602.57 270.729C636 277.609 737.9 243.219 778.31 245.029C853.65 248.419 944.62 273.139 991.31 265.559C1016.41 261.489 1020.82 223.219 1020.82 223.219C1020.82 223.219 1004.17 168.809 802.69 166.809Z",
    fill: "url(#paint15_linear_1951_32086)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M802.69 166.809C586.6 164.609 564.05 202.729 564.05 202.729C564.05 202.729 554.89 222.929 584.57 247.639C593.28 254.889 584.45 266.989 602.57 270.729C636 277.609 737.9 243.219 778.31 245.029C853.65 248.419 944.62 273.139 991.31 265.559C1016.41 261.489 1020.82 223.219 1020.82 223.219C1020.82 223.219 1004.17 168.809 802.69 166.809Z",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M793.71 223.22C581.85 218.3 589.71 268.13 589.71 268.13C589.71 268.13 611.54 312.43 805.25 313.03C985.94 313.59 997.71 273.26 997.71 273.26C997.71 273.26 1012.33 228.3 793.71 223.22Z",
    fill: "url(#paint16_linear_1951_32086)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M793.71 223.22C581.85 218.3 589.71 268.13 589.71 268.13C589.71 268.13 611.54 312.43 805.25 313.03C985.94 313.59 997.71 273.26 997.71 273.26C997.71 273.26 1012.33 228.3 793.71 223.22Z",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M786.001 239.899C617.881 240.389 633.321 279.669 633.321 279.669C633.321 279.669 649.561 310.619 787.321 313.029C955.501 315.979 954.121 280.959 954.121 280.959C954.121 280.959 965.001 239.379 786.001 239.899Z",
    fill: "url(#paint17_linear_1951_32086)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M786.001 239.899C617.881 240.389 633.321 279.669 633.321 279.669C633.321 279.669 649.561 310.619 787.321 313.029C955.501 315.979 954.121 280.959 954.121 280.959C954.121 280.959 965.001 239.379 786.001 239.899Z",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M800.12 813.41C800.12 813.41 812.12 800.58 824.5 800.58C835.84 800.58 847.59 813.41 847.59 813.41V849.34C847.59 849.34 854.33 855.34 851.44 855.75C840.53 857.43 805.04 855.75 796.27 855.75C794.02 855.75 800.12 849.34 800.12 849.34V813.41Z",
    fill: "url(#paint18_linear_1951_32086)",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M940.001 283.52C939.471 282.83 942.801 251.2 779.621 251.45C641.511 251.66 646.191 283.52 646.191 283.52L668.001 311.75C668.001 311.75 816.001 327.95 896.381 319.45C933.631 315.51 941.571 285.59 940.001 283.52Z",
    fill: "url(#paint19_linear_1951_32086)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M940.001 283.52C939.471 282.83 942.801 251.2 779.621 251.45C641.511 251.66 646.191 283.52 646.191 283.52L668.001 311.75C668.001 311.75 816.001 327.95 896.381 319.45C933.631 315.51 941.571 285.59 940.001 283.52Z",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M933.56 333.56C920.56 288.75 654.72 292.69 656.42 328.43C658.12 364.17 941.5 372.13 933.56 333.56Z",
    fill: "url(#paint20_linear_1951_32086)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M933.56 333.56C920.56 288.75 654.72 292.69 656.42 328.43C658.12 364.17 941.5 372.13 933.56 333.56Z",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M929.711 333.56L920.561 334.17C920.561 334.17 901.721 420.17 905.331 419.52C906.001 419.41 931.001 405.41 931.001 405.41L929.711 333.56Z",
    fill: "url(#paint21_linear_1951_32086)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M929.711 333.56L920.561 334.17C920.561 334.17 901.721 420.17 905.331 419.52C906.001 419.41 931.001 405.41 931.001 405.41L929.711 333.56Z",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M933.56 320.73C933.56 319.73 921.46 288.68 783.44 291.22C666.1 293.39 656.44 316.88 656.44 316.88V329.71C656.44 329.71 893.66 337.22 931.01 333.56C934.22 333.25 933.56 321.03 933.56 320.73Z",
    fill: "url(#paint22_linear_1951_32086)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M933.56 320.73C933.56 319.73 921.46 288.68 783.44 291.22C666.1 293.39 656.44 316.88 656.44 316.88V329.71C656.44 329.71 893.66 337.22 931.01 333.56C934.22 333.25 933.56 321.03 933.56 320.73Z",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M852.73 311.75C852.73 311.24 817.91 306.16 803.97 305.34L796.271 307.9V328.43C796.271 328.43 798.491 330.43 798.841 334.84C799.741 346.23 802.69 368.2 802.69 368.2L828.3 381.7L848.88 369.49C848.88 369.49 845.1 334.15 852.73 331C856.25 329.54 852.73 312.72 852.73 311.75Z",
    fill: "url(#paint23_linear_1951_32086)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M852.73 311.75C852.73 311.24 817.91 306.16 803.97 305.34L796.271 307.9V328.43C796.271 328.43 798.491 330.43 798.841 334.84C799.741 346.23 802.69 368.2 802.69 368.2L828.3 381.7L848.88 369.49C848.88 369.49 845.1 334.15 852.73 331C856.25 329.54 852.73 312.72 852.73 311.75Z",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M680.8 331V345.11L682.08 381.03L675.67 397.71L688.5 399L696.2 381L697.48 345.08V331C697.48 329.97 680.8 331 680.8 331Z",
    fill: "url(#paint24_linear_1951_32086)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M680.8 331V345.11L682.08 381.03L675.67 397.71L688.5 399L696.2 381L697.48 345.08V331C697.48 329.97 680.8 331 680.8 331Z",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M864.271 307.9L809.101 302.77L803.971 305.33V325.86L809.101 328.43L811.671 361.79L828.351 381.03L860.421 364.35V331L865.561 324.58L864.271 307.9Z",
    fill: "url(#paint25_linear_1951_32086)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M864.271 307.9L809.101 302.77L803.971 305.33V325.86L809.101 328.43L811.671 361.79L828.351 381.03L860.421 364.35V331L865.561 324.58L864.271 307.9Z",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M905.331 334.84L904.051 409.26V415.68L920.731 403.31V334.33L905.331 334.84Z",
    fill: "url(#paint26_linear_1951_32086)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M905.331 334.84L904.051 409.26V415.68L920.731 403.31V334.33L905.331 334.84Z",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M666.69 329.709C665.63 328.649 666.69 388.709 666.69 388.709L675.69 397.709C679.832 393.021 682.509 387.222 683.39 381.029C685.56 362.439 685.95 331.029 685.95 331.029C685.95 331.029 667.08 330.109 666.69 329.709Z",
    fill: "url(#paint27_linear_1951_32086)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M666.69 329.709C665.63 328.649 666.69 388.709 666.69 388.709L675.69 397.709C679.832 393.021 682.509 387.222 683.39 381.029C685.56 362.439 685.95 331.029 685.95 331.029C685.95 331.029 667.08 330.109 666.69 329.709Z",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M678.23 817.26L669.23 804.43C669.23 804.43 659.77 816.57 660.23 817.26C660.69 817.95 658.66 855.58 660.23 855.75C662.14 855.96 675.31 860.88 678.23 854.47C683.36 843.1 678.23 817.26 678.23 817.26Z",
    fill: "url(#paint28_linear_1951_32086)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M678.23 817.26L669.23 804.43C669.23 804.43 659.77 816.57 660.23 817.26C660.69 817.95 658.66 855.58 660.23 855.75C662.14 855.96 675.31 860.88 678.23 854.47C683.36 843.1 678.23 817.26 678.23 817.26Z",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M678.23 817.26V855.75L694.91 854.47V817.26H678.23Z",
    fill: "url(#paint29_linear_1951_32086)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M678.23 817.26V855.75L694.91 854.47V817.26H678.23Z",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M687.221 804.43H669.221C669.221 804.43 676.121 821.11 678.221 821.11C681.331 821.11 693.321 824.61 694.901 819.83C696.001 816.56 687.221 804.43 687.221 804.43Z",
    fill: "url(#paint30_linear_1951_32086)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M687.221 804.43H669.221C669.221 804.43 676.121 821.11 678.221 821.11C681.331 821.11 693.321 824.61 694.901 819.83C696.001 816.56 687.221 804.43 687.221 804.43Z",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M919.441 804.43H904.051L905.331 855.75H920.731L919.441 804.43Z",
    fill: "url(#paint31_linear_1951_32086)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M919.441 804.43H904.051L905.331 855.75H920.731L919.441 804.43Z",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M565.33 225.81L804 192.43L565.33 225.81Z",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M821.93 273.259C821.93 273.259 761.4 273.259 712.93 278.389C692.448 280.638 672.244 284.936 652.62 291.219C672.825 284.919 693.586 280.566 714.62 278.219C762.9 273.109 821.93 273.259 821.93 273.259Z",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M711.591 278.39L706.461 255.3L711.591 278.39Z",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M822.52 318.739L838.61 319.449M821.501 345.5L859.591 346.21",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M676.07 330.31L675.67 397.71",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M839 306V329",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M823 252V291M804.5 168V193M679.5 210V227",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M822 318V374",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M824.5 856.75L821.93 800.3L824.5 856.75Z",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M809 909.81L808.93 869.3L809 909.81Z",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M825 830L849 829L825 830Z",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M914.31 844.36L911.75 804.58L914.31 844.36Z",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M670.001 842.81L668.721 805.6L670.001 842.81Z",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M834.76 969.939L833.48 949.409",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M860 949L859.5 935L859 921",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M799 951L798.5 937L798 923",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M797.561 937.869L648.721 931.449L797.561 937.869Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M936.56 898.869L809 899.809",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M859 949L798 950",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M661 1045V1090L637 1127.5L618 1126.5L661 1045Z",
    fill: "#020A25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M913.5 1041L920.5 1094.5L938.5 1129H963L913.5 1041Z",
    fill: "#020A25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M638 1088L659.119 1046.53",
    stroke: "black",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M596.881 1083.47L618 1042",
    stroke: "black",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M661.5 1089.5L660 1044.04",
    stroke: "black",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M921 1094L916.001 1042.04",
    stroke: "black",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M915.08 1042.3L943.5 1093",
    stroke: "black",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M969 1038.47L1001.18 1096.33",
    stroke: "black",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 999.976,
    y1: 1096,
    x2: 1292.98,
    y2: 1089,
    stroke: "black",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1512,
    height: 405,
    fill: "url(#paint32_linear_1951_32086)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M661.5 1089L920.5 1094L933.5 1117L647 1111L661.5 1089Z",
    fill: "url(#paint33_linear_1951_32086)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1951_32086",
    x1: -48.22,
    y1: 635.8,
    x2: 1555.28,
    y2: 495.51,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0E1B5E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#081743"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#021326"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1951_32086",
    x1: 457.101,
    y1: 1027.94,
    x2: 1114.84,
    y2: 1027.94,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17244D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#04152B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1951_32086",
    x1: 789.8,
    y1: 1097.25,
    x2: 789.8,
    y2: 1030.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000912",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000912"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1951_32086",
    x1: 459.911,
    y1: 995.02,
    x2: 1112.09,
    y2: 937.96,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#08112B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#08112B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1951_32086",
    x1: 501.14,
    y1: 966.96,
    x2: 538.86,
    y2: 963.66,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0E1B5E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#051535"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#021326"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1951_32086",
    x1: 613,
    y1: 981.31,
    x2: 651,
    y2: 981.31,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0E1B5E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#051535"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#021326"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1951_32086",
    x1: 953,
    y1: 974.31,
    x2: 991,
    y2: 974.31,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0E1B5E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#051535"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#021326"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1951_32086",
    x1: 831,
    y1: 982.31,
    x2: 869,
    y2: 982.31,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0E1B5E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#051535"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#021326"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1951_32086",
    x1: 727,
    y1: 984.31,
    x2: 765,
    y2: 984.31,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0E1B5E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#051535"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#021326"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_1951_32086",
    x1: 1039,
    y1: 958.31,
    x2: 1077,
    y2: 958.31,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0E1B5E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#051535"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#021326"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_1951_32086",
    x1: 797.271,
    y1: 888.72,
    x2: 790.921,
    y2: 837.01,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#04152B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#17244D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_1951_32086",
    x1: 633.33,
    y1: 919.98,
    x2: 961.78,
    y2: 919.98,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#04152B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#17244D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_1951_32086",
    x1: 648.72,
    y1: 853.19,
    x2: 937.41,
    y2: 853.19,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#08112B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#08112B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_1951_32086",
    x1: 619.18,
    y1: 970.78,
    x2: 619.18,
    y2: 856.15,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#041532"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#010913"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_1951_32086",
    x1: 916.75,
    y1: 903.559,
    x2: 1033.18,
    y2: 917.859,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#010913"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#041532"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_1951_32086",
    x1: 580.93,
    y1: 282.639,
    x2: 1006.19,
    y2: 168.689,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17244D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#04152B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_1951_32086",
    x1: 590.18,
    y1: 257.54,
    x2: 997.54,
    y2: 278.89,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0D1A40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#03152B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_1951_32086",
    x1: 632.961,
    y1: 276.549,
    x2: 954.211,
    y2: 276.549,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0D1A40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#03152B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_1951_32086",
    x1: 791.7,
    y1: 840.22,
    x2: 850.55,
    y2: 824.46,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17244D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#04152B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_1951_32086",
    x1: 657.431,
    y1: 325.57,
    x2: 931.631,
    y2: 252.1,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17244D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#04152B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_1951_32086",
    x1: 666.27,
    y1: 365.79,
    x2: 923.71,
    y2: 296.81,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#03152B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#04152B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_1951_32086",
    x1: 904.871,
    y1: 376.55,
    x2: 930.991,
    y2: 376.55,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17244D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#04152B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_1951_32086",
    x1: 663.6,
    y1: 356.48,
    x2: 924.42,
    y2: 286.59,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#04152B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#17244D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_1951_32086",
    x1: 797.421,
    y1: 348.53,
    x2: 858.22,
    y2: 332.24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#04152B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#17244D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_1951_32086",
    x1: 675.67,
    y1: 364.77,
    x2: 697.48,
    y2: 364.77,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17244D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#04152B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_1951_32086",
    x1: 803.971,
    y1: 341.9,
    x2: 865.561,
    y2: 341.9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17244D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#04152B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_1951_32086",
    x1: 912.391,
    y1: 415.67,
    x2: 912.391,
    y2: 334.33,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#04152B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#17244D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_1951_32086",
    x1: 676.07,
    y1: 397.709,
    x2: 676.07,
    y2: 329.699,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#04152B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#17244D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_1951_32086",
    x1: 659.67,
    y1: 831.09,
    x2: 680.51,
    y2: 831.09,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0E1B5E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#0C1A54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#04152B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_1951_32086",
    x1: 678.23,
    y1: 836.51,
    x2: 694.91,
    y2: 836.51,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0E1B5E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#0C1A54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#04152B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_1951_32086",
    x1: 669.251,
    y1: 813.39,
    x2: 695.011,
    y2: 813.39,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0E1B5E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#0C1A54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#04152B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_1951_32086",
    x1: 904.051,
    y1: 830.09,
    x2: 920.731,
    y2: 830.09,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0E1B5E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#0C1A54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#04152B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_1951_32086",
    x1: 756,
    y1: 0,
    x2: 756,
    y2: 405,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#011122"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#021325",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_1951_32086",
    x1: 788.5,
    y1: 1091,
    x2: 788.5,
    y2: 1111,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0D1B39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D1B38",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1951_32086"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1512,
    height: 1127,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1951_32086"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1550.11,
    height: 1138.68,
    fill: "white",
    transform: "translate(-16)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOver);
export default __webpack_public_path__ + "static/media/over.d9198cde3f43a982119a6a363acde295.svg";
export { ForwardRef as ReactComponent };